<template>
<div>
    <div class="conList">
            <p>{{$t('exhibitor.demandTip')}}</p>
          </div>
          <div class="feedbackwrap">
        <el-input
            type="textarea"
            :rows="2"
            :placeholder="placeholder"
            resize="none"
            v-model="textarea">
        </el-input>
        <div class="feedback-btn" @click="getData">{{$t('business.submit')}}</div>
  </div>
</div>
  
</template>

<script>
import { getFeedback } from "@/api/api";
export default {
  props: {
    'subData':Function
  },
  data() {
    return {
      textarea: '',
      placeholder: ''
    }
  },
  created() {
  },
  mounted() {
    this.placeholder = this.$t('business.demandType')
    this.memberid = localStorage.getItem('memberid');
  },
  methods: {
    getData(){
      this.subData(this.textarea);
      // if(this.textarea.length > 0){
      //   let data = this.$qs.stringify({
      //     memberid: this.memberid,
      //     content:this.textarea
      //   })
      //   getFeedback(data).then(res=>{
      //     if(res.data.errno == 0){
      //       this.$message('提交成功！');
      //     }else{
      //       this.$message(res.data.errmsg);
      //     }
      //   }).catch(err=>{
      //     console.log(err)
      //   })
      // }else{
      //   this.$message('内容不能为空！');
      // }
      
    },
  }
}
</script>

<style scoped>
.conList{
  width: 100%;
/* height: 32px; */
background: #F8F8F8;
/* line-height: 32px; */
padding: 9px 0;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
margin:0 auto 13px;

}
.conList p{
  padding-left: 20px;
}
.feedbackwrap .feed-title{font-size:20px;line-height: 28px;color: #000;padding-bottom: 12px;}
.feedbackwrap .el-textarea__inner{height: 184px;background:rgba(248,248,248,1);border-radius:1px;border:1px solid rgba(229,229,229,1);font-size:18px;font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;}
.feedbackwrap .el-textarea__inner:focus,.el-textarea__inner:hover{border-color: rgba(229,229,229,1);}
.feedbackwrap .feedback-btn{width:153px;height:40px;
background: linear-gradient(180deg, #CCD280 0%, #C4CA78 29%, #B8BE6B 69%, #A1A751 100%);border-radius:3px;text-align: center;line-height: 40px;color: #fff;font-size:18px;margin: 68px auto 40px;cursor: pointer;}
@media only screen and (max-width: 767px){
    .conList{
  width: 100%;
/* height: 32px; */
background: #F8F8F8;
/* line-height: 32px; */
padding: 9px 0;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
margin:0 auto;
}
.conList p{
  padding-left: 20px;
}
  .feedbackwrap .feed-title{font-size: 16px;}
  .feedbackwrap .el-textarea__inner{font-size: 14px;height: 1.84rem;}
  .feedbackwrap .feedback-btn{width: 1.53rem;height: 0.4rem;line-height: 0.4rem;font-size: 14px;}
}
</style>